import Axios from 'axios';
import { sessionMiddleware } from './login';
import { ThemeSettings } from '../model/themes/types';

export default class ThemesAPI
{
    // ------- LOGS ------- //

    static getThemes() : Promise<ThemeSettings>
    {
        return Axios.get('./api/themes/')
        .then(sessionMiddleware)
        .then((response: any) => {
            return response.data as ThemeSettings;
        }).catch((error: any) => {
            console.log(error);
            return {} as ThemeSettings;
        });
    }

    // ---------------------- //
}